import { inject, Injectable } from '@angular/core';
import { EipUser } from './eip.model';
import { UserFacade, UserRole } from '@schir-int-client/user-shared';
import { filter, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EipContext {
	private userFacade = inject(UserFacade);

	private eipUser: EipUser;

	constructor() {
		this.userFacade
			.getCurrentUser()
			.pipe(
				filter(u => u != null),
				take(1)
			)
			.subscribe(user => {
				this.eipUser = {
					firstName: user.firstName,
					lastName: user.lastName,
					jobDescription: user.roles.includes(UserRole.RECHTSPFLEGER) ? 'Rechtspfleger:in' : 'Mitarbeiter:in',
					title: 'Herr/Frau',
					loginId: user.shortId,
				};
			});
	}

	currentUser(): EipUser {
		return this.eipUser;
	}
}
